import Icon from "@react-native-vector-icons/material-design-icons/static";
import { View } from "react-native";
import { Button, List } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import { FlatCard } from "../Cards/FlatCard";
import MemorangIcons from "../MemorangIcons";
import { ProductsSectionSkeleton } from "./ProductsSectionSkeleton";
import type { ProductsSectionItem } from "./types";

interface Props {
	items: ProductsSectionItem[];
	isLoading?: boolean;
	onPressItem: (link: string) => void;
}

export const ProductsSection = ({
	items,
	isLoading = false,
	onPressItem,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	return (
		<FlatCard
			accessibilityLabel={`Products section, contains ${items.map((item) => item.title).join(", ")}`}
			accessible
			style={{ overflow: "hidden" }}
		>
			{isLoading ? (
				<ProductsSectionSkeleton isMobile={isMobile} />
			) : (
				<View>
					{items.map(({ link, title, icon, subtitle, custom }) => (
						<List.Item
							title={title}
							key={title}
							onPress={() => onPressItem(link)}
							accessibilityLabel={`Product item - ${title}, ${subtitle ?? "No subtitle"}`}
							accessible
							style={{
								width: "100%",
							}}
							descriptionStyle={{
								fontSize: 12,
							}}
							description={subtitle}
							left={(props) => (
								<List.Icon
									{...props}
									icon={() => {
										return custom ? (
											<MemorangIcons
												name={icon}
												size={24}
												color={theme.colors.onSurfaceVariant}
												accessibilityLabel={title}
												accessible
											/>
										) : (
											<Icon
												name={icon as IconType}
												size={24}
												color={theme.colors.onSurfaceVariant}
												accessibilityLabel={title}
												accessible
											/>
										);
									}}
								/>
							)}
							right={(props) => (
								<List.Icon
									{...props}
									icon={() => {
										return (
											<Button onPress={() => onPressItem(link)}>Browse</Button>
										);
									}}
								/>
							)}
						/>
					))}
				</View>
			)}
		</FlatCard>
	);
};
